import { Box, Flex, Image, Text } from "@chakra-ui/react";
import React from "react";
import l1 from "../../assets/Home/p1.png";
import l2 from "../../assets/Home/p2.png";
import banner from "../../assets/Home/banner.png";
const WishfyArtFrames = () => {
  return (
    <Box textAlign={"center"}>
      <Box mt={14}>
        <Image src={banner} w={"100%"} />
      </Box>
      {/* <Box mt={14}>
        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={30}
          textAlign={"left"}
        >
          OFFERS
        </Text>
        <Flex
          gap={8}
          w={"100%"}
          mt={5}
          flexDirection={{ md: "row", base: "column" }}
        >
          <Image src={l1} w={{ md: "49%", base: "100%" }} />
          <Image src={l2} w={{ md: "49%", base: "100%" }} />
        </Flex>
      </Box> */}
    </Box>
  );
};

export default WishfyArtFrames;
